import HistoryPlaceholder from './HistoryPlaceholder';

export default HistoryPlaceholder;
